import { PERSIST_STORE_NAME } from "constants/app.constant";
import rootReducer from "./rootReducer";
import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";

import { modelEngineService } from "../services/ModelEngineService";
import { datasetService } from "../services/DatasetService";
import { marketplaceService } from "../services/MarketplaceService";
import { otherServiceApi } from "../services/OtherServices";
import { billingApi } from "../services/BillingService";
import { projectService, channelService } from "../services/ProjectService";
import { modelService } from "../services/ModelService";
import { authService } from "../services/AuthService";
import { logServices } from "../services/LogService";
import { CommonService } from "../services/CommonService";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { labelCraftServiceApi } from '../services/LabelCraftServices';
import { customerServiceApi } from '../services/CustomerService';

import { createLogger } from "redux-logger";
import { authorizationMiddleware } from "./middlewares";
import { Environment, getEnvironment } from "utils/getEnvironment";
import { competitionService } from "services/competitionService";

// Only useful for development
const logger = createLogger({
  collapsed: true,
});

const persistConfig = {
  key: PERSIST_STORE_NAME,
  keyPrefix: "",
  storage,
  whitelist: ["auth", "theme", "flow", "rightPanel", "app"],
  stateReconciler: autoMergeLevel2,
};

const middlewares = [
  modelEngineService.middleware,
  datasetService.middleware,
  marketplaceService.middleware,
  otherServiceApi.middleware,
  billingApi.middleware,
  projectService.middleware,
  modelService.middleware,
  authService.middleware,
  logServices.middleware,
  CommonService.middleware,
  authorizationMiddleware,
  labelCraftServiceApi.middleware,
  competitionService.middleware,
  customerServiceApi.middleware,
  channelService.middleware
  // getEnvironment(Environment.DEVELOPMENT) ? logger : undefined,
];


const store = configureStore({
  reducer: persistReducer(persistConfig, rootReducer()),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middlewares),
  devTools: getEnvironment(Environment.DEVELOPMENT) ? true : false, 
});

store.asyncReducers = {};

setupListeners(store.dispatch);

export const persistor = persistStore(store);

export const injectReducer = (key, reducer) => {
  if (store.asyncReducers[key]) {
    return false;
  }
  store.asyncReducers[key] = reducer;
  store.replaceReducer(
    persistReducer(persistConfig, rootReducer(store.asyncReducers))
  );
  persistor.persist();
  return store;
};

export default store;
